export default "__VITE_ASSET__BWgia1s9__"